var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"forms-block"},[(_vm.showLogin==true)?_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Login")]),_c('FormLogin')],1):_vm._e(),(_vm.showLogin==false)?_c('div',{staticClass:"form"},[_c('h2',[_vm._v("Register")]),_c('FormRegister')],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }